import React, { useRef, useState, useEffect } from "react";

import "./copytoclipboard.styles.css";

export default function CopyToClipboard() {
  const [copySuccess, setCopySuccess] = useState("e-fadeout");
  const textAreaRef = useRef(null);

  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand("copy");
    e.target.focus();
    setCopySuccess("");
  }

  useEffect(() => {
    return function cleanup() {
      setCopySuccess("e-fadeout");
    };
  });

  return (
    <>
      <form>
        <textarea id="copytoclipboard" ref={textAreaRef} value="Select a step to share" readOnly />
      </form>
      {/* Logical shortcut for only displaying the 
          button if the copy command exists */
      document.queryCommandSupported("copy") && (
        <div>
          <button onClick={copyToClipboard}>Copy</button>
          <span className={`copysuccess ${copySuccess}`}>Copied to clipboard!</span>
        </div>
      )}
    </>
  );
}
